<template>
  <!--商品列表-->
  <tk-container
    :status="status"
    infiniteScroll
    hide-status-bar
    class="container-wrap"
    ref="resetCommodityList"
    @refresh="refreshInit"
    @loadingMore="getSearchCommodity"
  >
    <!--列表头部-->
    <tkui-header class="search-header" slot="header">
      <div slot="left-menu" @click="$back">
        <tkui-button class="icon">
          <tk-icon size="16" color="#666">fanhui</tk-icon>
        </tkui-button>
      </div>
      <!--搜索框显示-->
      <div class="search-show" @click="toggleSearch">
        <div class="search-show-word" v-show="searchShow && showWord">
          {{showWord}}
          <tk-icon size="8" color="#fff" class="m-l-10">guanbi</tk-icon>
        </div>
      </div>
    </tkui-header>
    <!--列表tab(这里为点击切换)-->
    <tk-flex
      slot="header"
      around middle
      class="tabs-wrap"
    >
      <div
        v-for="(s, index) in searchTab"
        :key="index"
        @click="selectTab(index)"
        :class="{'selected-tab': s.active === true}"
      >
        {{s.text}}
        <span
          v-if="s.active === true && index !== 0"
          @click.stop="toggleDirection(index)"
          class="selected-tab-subscript"
        >
          <tk-icon size="12">{{s.direction === 'upDown' ? 'didaogao' : 'gaodaodi'}}</tk-icon>
        </span>
      </div>
    </tk-flex>
    <!--商品列表-->
    <div class="b-g-f p-x-12 p-y-5" v-if="searchProductsData.length">
      <div
        v-for="(s, index) in getPriceProcessing(searchProductsData, judgeTimeRule)"
        :key="index"
      >
        <commodity-single
          :commodity="s"
          :image-size="130"
          :judge-time="judgeTimeRule"
        ></commodity-single>
        <div v-if="index < (searchProductsData.length - 1)" class="m-y-5" style="width: 100%;height: 1px;background: #f5f5f5;"></div>
      </div>
    </div>
  </tk-container>
</template>

<script>
import commoditySingle from '@/components/commoditySingle'
import { priceProcessing } from '@/assets/help/tool'
export default {
  components: {
    commoditySingle
  },
  data () {
    return {
      status: 'loading', // 页面状态
      searchShow: true, // 搜索词的显示
      tabIndex: 0, // tab索引
      timeRule: {}, // 限时抢购时间规则
      searchTab: [ // tab切换数据
        {
          text: '综合',
          active: true,
          direction: 'upDown'
        },
        {
          text: '新品',
          active: false,
          direction: 'upDown'
        },
        {
          text: '销量',
          active: false,
          direction: 'upDown'
        },
        {
          text: '价格',
          active: false,
          direction: 'upDown'
        }
      ],
      searchProductsData: [] // 搜索的商品数据
    }
  },
  computed: {
    // 判断抢购时间是否有效
    judgeTimeRule () {
      if (!this.timeRule) return false
      let endSum = new Date(this.timeRule.endTime).getTime()
      let nowSum = new Date().getTime()
      return nowSum - endSum < 0
    },
    // 搜索框显示词
    showWord () {
      return this.$getFlash('searchWord')
    },
    // 商品排序条件
    sortCondition () {
      let obj = {
        limit: 10,
        include: 'panicBuying',
        where: {
          shelvesStatus: 'shelves'
        }
      }
      // 按类别（搜索，分类）-> 按是否终端判断价格 -> 按tab排序
      if (this.$route.query.type === 'search') { // 搜索下的判断条件
        obj.where.productTitle = {
          $regex: `${this.showWord}`
        }
      } else {
        obj.where.category = this.$route.query.classId
      }
      // 按tab排序
      if (this.tabIndex === 0) { // 综合排序条件
        if (this.isTerminalAccount) { obj.order = '-sales,-terminalPrice,weight' } else {
          // obj.order = '-sales,-countyPrice,-createdAt'
          obj.order = '-sales,-countyPrice,-weight'
        }
      } else if (this.tabIndex === 1) { // 新品排序条件
        if (this.searchTab[1].direction === 'upDown') { obj.order = 'weight' } else {
          // obj.order = 'createdAt'
          obj.order = '-weight'
        }
      } else if (this.tabIndex === 2) { // 销量排序条件
        if (this.searchTab[2].direction === 'upDown') { obj.order = '-sales' } else {
          obj.order = 'sales'
        }
      } else if (this.tabIndex === 3) { // 价格排序条件
        if (this.isTerminalAccount && this.searchTab[3].direction === 'upDown') {
          obj.order = '-terminalPrice'
        } else if (this.isTerminalAccount && this.searchTab[3].direction === 'downUp') {
          obj.order = 'terminalPrice'
        } else if (!this.isTerminalAccount && this.searchTab[3].direction === 'upDown') {
          obj.order = '-countyPrice'
        } else if (!this.isTerminalAccount && this.searchTab[3].direction === 'downUp') {
          obj.order = 'countyPrice'
        }
      }
      return obj
    }
  },
  activated () {
    this.setStatusBar('dark')
  },
  mounted () {
    this.getInit()
  },
  beforeRouteLeave (to, from, next) {
    next(true)
  },
  methods: {
    /**
    * 数据初始化
    * @date: 2020/4/8
    */
    async getInit () {
      try {
        this.addSearchWord() // 搜索的值保存store
        this.searchShow = true
        await this.getLimitedTimeRule() // 获取限时抢购的时间 （只获取1条）
        this.status = false
      } catch (e) {
        this.status = 'error'
        this.$tkGlobal.toast.add('加载数据失败')
      }
    },
    /**
     * 页面错误时点击重新加载按钮 @resetInfiniteScroll
     * @date: 2020/3/24
     */
    async refreshInit () {
      this.tabIndex = 0
      this.searchProductsData = []
      await this.getInit()
      this.$refs.resetCommodityList.resetInfiniteScroll()
    },
    /**
    * 搜索的值添加到store
    * @date: 2020/4/8
    */
    addSearchWord () {
      if (this.$route.query.type !== 'search') { return }
      let word = this.showWord
      let arr = this.$store.state.searchWords
      if (!arr.length) {
        arr.unshift(word)
        this.$store.commit('setSearchWords', arr)
        return
      }
      let index = arr.findIndex(s => { return s === word })
      if (index === -1) {
        arr.unshift(word)
        if (arr.length > 5) {
          arr.pop()
        }
        this.$store.commit('setSearchWords', arr)
      }
    },
    /**
    * 切换页面时搜索词的显示
    * @date: 2020/4/9
    */
    toggleSearch () {
      this.searchShow = false
      this.$setFlash('toggleSearch', this.$route.query.type)
      this.$replace('/common/searchPage')
    },
    /**
    * 切换tab标签
    * @date: 2020/4/10
    */
    selectTab (index) {
      this.searchTab[index].active = true
      this.searchTab.forEach((s, inX) => { if (index !== inX) { s.active = false } })
      this.tabIndex = index
      this.searchProductsData = []
      if (this.status !== 'loading') { this.$refs.resetCommodityList.resetInfiniteScroll() }
    },
    /**
    * 切换方向
    * @date: 2020/4/10
    */
    toggleDirection (index) {
      if (index === 0) {
        this.searchTab.forEach((s, inX) => { if (index !== inX) { s.direction = 'upDown' } })
        return
      }
      if (this.searchTab[index].direction === 'upDown') {
        this.searchTab[index].direction = 'downUp'
      } else {
        this.searchTab[index].direction = 'upDown'
      }
      this.searchTab.forEach((s, inX) => { if (index !== inX) { s.direction = 'upDown' } })
      this.searchProductsData = []
      this.$forceUpdate()
      if (this.status !== 'loading') { this.$refs.resetCommodityList.resetInfiniteScroll() }
    },
    /**
     * 限时抢购时间获取
     * @date: 2020/3/20
     */
    async getLimitedTimeRule () {
      let isoStartDate = new Date().toISOString()
      let startTime = await this.$tkAjax.get('https://cloud.dianpei.mokekeji.com/settings/startTime').catch(e => {
        return { data: null }
      })
      let endTime = await this.$tkAjax.get('https://cloud.dianpei.mokekeji.com/settings/endTime').catch(e => {
        return { data: null }
      })
      // 判断时间是否存在
      if (!startTime.data || !endTime.data) {
        this.timeRule = null
        return
      }
      let startSum = new Date(startTime.data).getTime()
      let nowSum = new Date(isoStartDate).getTime()
      if (nowSum <= startSum) {
        this.timeRule = null
        return
      }
      this.timeRule = {
        startTime: startTime.data,
        endTime: endTime.data
      }
    },
    /**
     * 商品价格处理
     * @date: 2020/4/2
     */
    priceProcessing (arr) {
      arr.forEach(s => {
        if (this.isTerminalAccount) {
          if (this.judgeTimeRule && s.panicBuying) {
            s.price = s.panicBuying.terminalPrice
            s.oldPrice = s.terminalPrice
          } else {
            s.price = s.terminalPrice
          }
        } else {
          if (this.judgeTimeRule && s.panicBuying) {
            s.price = s.panicBuying.countyPrice
            s.oldPrice = s.countyPrice
          } else {
            s.price = s.countyPrice
          }
        }
      })
      return arr
    },
    /**
    * 搜索词，新品，销量，价格 获取商品数据
    * $regex: `${searchWord}`
    * @date: 2020/4/10
    */
    async getSearchCommodity (page, next) {
      let obj = this.$tkHelper.deepClone(this.sortCondition)
      obj.skip = page * 10
      let commodityData = await this.$tkParse.getList(`/classes/commodity`, {
        params: obj
      })
      this.searchProductsData = [...this.searchProductsData, ...commodityData]
      if (commodityData.length < 10) {
        next('complete')
      } else {
        next('+1')
      }
    },
    /**
     * 工具转换
     * @date: 2020/4/10
     */
    getPriceProcessing (arr, rule) {
      return priceProcessing(arr, rule)
    }
  }
}
</script>

<style scoped lang="scss">
  /*头部样式*/
  .search-header {
    background: rgba(255, 255, 255, 0);
    padding-right: 15px !important;
    padding-top: 30px !important;
    .search-show {
      width: 100%;
      height: 34px;
      background-color: rgba(255, 255, 255, 1);
      padding-top: 4px;
      padding-left: 10px;
      border-radius: 17px;
    }
    .search-show-word {
      height: 26px;
      font-size: 14px;
      color: #fff;
      padding: 0 10px;
      line-height: 26px;
      position: absolute;
      text-align: center;
      background-color: rgba(153, 153, 153, 1);
      border-radius: 13px;
    }
  }
  /*tabs样式*/
  .tabs-wrap {
    height: 44px;
    font-size: 14px;
    .selected-tab {
      color: rgba(207, 22, 19, 1);
      .selected-tab-subscript {
        display: inline-block;
        width: 20px;
        margin-left: 5px;
      }
    }
  }
</style>
